import { useState } from 'react';

const ExpenseUpdateModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expenseData, setExpenseData] = useState({
    amount: '',
    description: '',
    source: '',
    date: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setExpenseData({
      ...expenseData,
      [name]: value,
    });
  };

  const handleUpdate = () => {
    // Handle the expense update logic here
    console.log('Updated Expense:', expenseData);
    setIsModalOpen(false); // Close the modal after updating
  };

  return (
    <div>
      <button
        className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 w-full sm:w-auto"
        onClick={() => setIsModalOpen(true)}
      >
        Update Expenses
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-md w-96">
            <h2 className="text-xl mb-4">Update Expense</h2>

            <form>
              <div className="mb-4">
                <label className="block text-sm font-medium">Expense Amount</label>
                <input
                  type="number"
                  name="amount"
                  value={expenseData.amount}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 mt-1 border rounded-md"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium">Expense Description</label>
                <input
                  type="text"
                  name="description"
                  value={expenseData.description}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 mt-1 border rounded-md"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium">Expense Source</label>
                <input
                  type="text"
                  name="source"
                  value={expenseData.source}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 mt-1 border rounded-md"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium">Expense Date</label>
                <input
                  type="date"
                  name="date"
                  value={expenseData.date}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 mt-1 border rounded-md"
                  required
                />
              </div>

              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={handleUpdate}
                  className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700"
                >
                  Update
                </button>
              </div>
            </form>

            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-2 right-2 text-xl text-gray-600"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpenseUpdateModal;
